import { Box, BoxProps, Text } from '@chakra-ui/react'
import { FaRegClock } from 'react-icons/fa'
import { FaCheck, FaCircleExclamation, FaTriangleExclamation } from 'react-icons/fa6'

interface TagStatusProps extends BoxProps {
  status: number
}

interface iConfigStatus {
  titulo: string
  cor: string
  fundo: string
  borda: string
  // Cor cheia, sem alpha: usada no marcador da timeline
  solida: string
  Icone: React.FC<{ size: number, color: string }>
}

export const configPorStatus: Record<number, iConfigStatus> = {
  0: {
    titulo: 'Pendente',
    cor: 'var(--Gray2)',
    fundo: 'var(--c6OpacoBg)',
    borda: 'var(--c5)',
    solida: 'var(--c6)',
    Icone: FaRegClock
  },
  1: {
    titulo: 'Solicitação de ajuste',
    cor: 'var(--OrangeEscuro)',
    fundo: 'var(--OrangeOpacoBg)',
    borda: 'var(--OrangeOpaco)',
    solida: 'var(--Orange)',
    Icone: FaCircleExclamation
  },
  2: {
    titulo: 'Assinado',
    cor: 'var(--Green1)',
    fundo: 'var(--Green2OpacoBg)',
    borda: 'var(--Green2Opaco)',
    solida: 'var(--Green2)',
    Icone: FaCheck
  },
  3: {
    titulo: 'Desatualizado',
    cor: 'var(--Gray3)',
    fundo: 'var(--Gray6)',
    borda: 'var(--Gray5)',
    solida: 'var(--Gray3)',
    Icone: FaTriangleExclamation
  }
}

export const TagStatus: React.FC<TagStatusProps> = ({ status, ...rest }) => {
  const config = configPorStatus[status] ?? configPorStatus[0]
  const { Icone } = config

  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      gap={'.375rem'}
      bgColor={config.fundo}
      color={config.cor}
      border={'1px solid'}
      borderColor={config.borda}
      borderRadius={'999px'}
      px={'.5rem'}
      py={'.125rem'}
      whiteSpace={'nowrap'}
      {...rest}
    >
      <Icone size={12} color={'currentColor'} />
      <Text fontSize={'12px'} fontWeight={'500'}>{config.titulo}</Text>
    </Box>
  )
}
